import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { Calendar, momentLocalizer, View } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Modal from "react-modal";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Autocomplete, Box, Dialog, FormControl, TextField, Typography } from "@mui/material";
import { Event, Margin } from "@mui/icons-material";
import '../../../assets/ExtraStyle.css'
import { date, string } from "yup";
import { ApiCompleteSlot, ApiCreateTrainingSlot, ApiDeleteBookingSlot, ApiGetAdminList, ApiGetAllocationlist, ApiGetAppliedAllocations, ApiGetMonthlyTrainings, ApiGetShopperList, ApiGetTrainingSlot, ApiResetSlot, ApiUpdateAvailabilitySlot } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);


// Initialize moment localizer
const localizer = momentLocalizer(moment);

// Define types for events
type Event = {
  id: number;
  title: string;
  TrainerName: string
  start: Date | string;
  end: Date | string;
  newAllocation: any;
  description?: string;
  type?: string;
  fileName?: string;
  shopperDetail?: any;
  availabilityDetails?: {
    availabilityId: number;
    startDateTime: string;
    endDateTime: string;
    slotDurationMinutes: number;
    notes: string;
  };
};

const TrainingCalendar: React.FC = () => {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const [events, setEvents] = useState<Event[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [newEventTitle, setNewEventTitle] = useState("");
  const [seletedSlotId, setseletedSlotId] = useState<any>(null);
  const [newTrainerName, setNewTrainerName] = useState("");
  const [newAllocation, setNewAllocation] = useState<any>("");
  const [newEventDescription, setNewEventDescription] = useState("");
  const [newEventType, setNewEventType] = useState("In Progress");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventDetails, setEventDetails] = useState<Event | null>(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [newEventFile, setNewEventFile] = useState<File | null>(null);
  const [currentView, setCurrentView] = useState<View>("week");
  const [showYearGrid, setShowYearGrid] = useState(false);
  const [openYearPicker, setOpenYearPicker] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startTime, setStartTime] = useState('09:00');
  const [endTime, setEndTime] = useState('09:30');
  const userId = localStorage.getItem('userId') || 0;
  const [shopperlist, setshopperlist] = useState([])
  const [adminlist, setadminlist] = useState([])
  const [selectedShopper, setSelectedShopper] = useState<any>()
  const [selectedAdmin, setSelectedAdmin] = useState<any>(localStorage.getItem('userId'))
  const [searchShopper, setsearchShopper] = useState<any>([])
  const [searchAdmin, setsearchAdmin] = useState<any>([])
  const [allocationData, setAllocationData] = useState<any>([]);
  const [allocationDate, setAllocationDate] = useState<Date | null>(null);
  const [allocationSearch, setAllocationSearch] = useState<string>("");
  const [allocationInput, setAllocationInput] = useState("");
  const [weekMonth, setWeekMonth] = useState<string>(() => {
    const startMonth = moment().startOf("week").month() + 1;
    const endMonth = moment().endOf("week").month() + 1;
    return startMonth === endMonth ? `${startMonth}` : `${startMonth},${endMonth}`;
  });
  const [duration, setDuration] = useState("30");

  // const [trainderdetails, setrainderDetails] = useState<any>({});

  // useEffect(() => {
  //   const trainerName: any =
  //     adminlist?.find((item: any) => item?.userId == selectedAdmin) ??
  //     localStorage.getItem("userName") ??
  //     "";
  //   setrainderDetails(trainerName)

  // }, [selectedAdmin, adminlist])
  const trainderdetails = useMemo(() => {
    return adminlist?.find((item: any) => item?.userId == selectedAdmin) ??
      localStorage.getItem("userName") ??
      "";
  }, [selectedAdmin, adminlist]);

  useEffect(() => {
    setSelectedAdmin(userId)
  }, [userId])
  useEffect(() => {
    setAllocationData([]);
    // setNewAllocation(null);
    const getallocationlist = async () => {
      if (!allocationDate || !selectedShopper) {
        return;
      }
      const data = `?offset=0&limit=500&userId=${selectedShopper.userId || selectedShopper?.shopperUserId}&jobMonth=${moment(allocationDate).month() + 1}&jobYear=${allocationDate?.getFullYear()}${allocationSearch ? `&venueName=${allocationSearch}` : ''}&status=approved`;
      try {
        const response = await ApiGetAppliedAllocations(data);
        setAllocationData(response.data);

      } catch (error) {
        console.log(error);
      }
    };

    if (selectedShopper && allocationDate) {
      getallocationlist();
    }
  }, [selectedShopper, allocationDate, allocationSearch]);




  useEffect(() => {
    if (!eventDetails?.newAllocation || allocationData.length === 0) return;

    const matched = allocationData.find((item: any) =>
      item?.allocationId?.allocationId === eventDetails?.newAllocation?.allocationId
    );

    if (matched) {
      setNewAllocation(matched);
    }
  }, [allocationData, eventDetails]);


  const getShopperList = async (text: any) => {
    setshopperlist([])
    try {
      const data = `?offset=0&limit=1000&status=active${text?.length > 0 ? `&search=${text}` : ''}`
      const res = await ApiGetShopperList(data)
      if (!text || text.length === 0) {
        const sortedList = res.data.sort((a: any, b: any) => {
          const aHasName = a.firstName && a.firstName.trim() !== '';
          const bHasName = b.firstName && b.firstName.trim() !== '';

          if (aHasName && bHasName) {
            return a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase());
          }

          if (aHasName && !bHasName) return -1;

          if (!aHasName && bHasName) return 1;

          return 0;
        });

        setshopperlist(sortedList)
      } else {
        setshopperlist(res.data)
      }

      // const originonal = res.data
      // setshopperlist(originonal)
      // const defaultselected = (res.data?.filter((item: any) => item.firstName !== ''))
      // setSelectedShopper(defaultselected[0])

    } catch (error) {
      alert(error)
    }
  }

  const handleGetAdminList = async () => {
    setadminlist([])
    const data = `?offset=0&limit=1000`
    try {
      const response: any = await ApiGetAdminList(data)
      response?.data?.map((item: any) => {
      })
      setadminlist(response.data)
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }
  useEffect(() => {
    getShopperList(searchShopper);
  }, [searchShopper])

  useEffect(() => {
    handleGetAdminList();
  }, [])

  const getTrainingSlots = async () => {
    try {
      // eve([])
      const data = `?userId=${selectedAdmin ?? localStorage.getItem('userId')}&month=${currentView == "week" ? weekMonth : currentDate?.getMonth() + 1}&year=${currentDate?.getFullYear()}`
      const res = await ApiGetTrainingSlot(data)

      if (res.status) {
        const final_data = res?.data?.editorSlots[0]
        const newEvents = final_data?.slots?.map((item: any) => {
          const startUTC = item.slotStart.replace(" ", "T") + ".000Z";
          const endUTC = item.slotEnd.replace(" ", "T") + ".000Z";
          const startDate = new Date(startUTC);
          const endDate = new Date(endUTC);
          setDuration(final_data?.slots?.[0]?.availabilityDetails?.slotDurationMinutes)
          const getMelbourneDate = (utcDateString: any) => {
            const utcDate = new Date(utcDateString);
            const melbourneString = utcDate.toLocaleString('en-US', {
              timeZone: trainderdetails?.timeZone
            });
            return new Date(melbourneString);
          };
          return {
            id: item.slotId,
            title:
              item?.statusName === "Booked"
                ? `${item?.shopperDetail?.firstName} ${item?.shopperDetail?.lastName}`
                : "",
            start: getMelbourneDate(startUTC),
            end: getMelbourneDate(endUTC),
            TrainerName: `${final_data?.firstName} ${final_data?.lastName}`,
            newAllocation: item?.allocationDetails,
            description: item?.availabilityDetails?.notes,
            type: item?.statusName,
            shopperDetail: item?.shopperDetail,
            availabilityDetails: item?.availabilityDetails
          };
        });
        setEvents(newEvents);
      }

    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }
  useEffect(() => {
    getTrainingSlots()
  }, [currentDate, selectedAdmin])

  // Handle navigation
  const handleNavigate = (direction: "prev" | "next") => {
    let newDate;
    if (currentView === "week") {
      newDate = (direction === "next")
        ? moment(currentDate).add(1, "week").toDate()
        : moment(currentDate).subtract(1, "week").toDate();

      const startOfWeek = moment(newDate).startOf("week");
      const endOfWeek = moment(newDate).endOf("week");

      const startMonth = startOfWeek.month() + 1; // 3
      const endMonth = endOfWeek.month() + 1;     // 4

      if (startMonth == endMonth) {
        setWeekMonth(`${startMonth}`); // "4"
      } else {
        setWeekMonth(`${startMonth},${endMonth}`); // "3,4"
      }
    } else if (currentView === "month") {
      newDate = direction === "next"
        ? moment(currentDate).add(1, "month").toDate()
        : moment(currentDate).subtract(1, "month").toDate();
    } else { // year view
      newDate = direction === "next"
        ? moment(currentDate).add(1, "year").toDate()
        : moment(currentDate).subtract(1, "year").toDate();
    }
    setCurrentDate(newDate);
  };
  // Handle month click in year view
  const handleMonthClick = (monthIndex: number) => {
    const newDate = moment(currentDate).month(monthIndex).toDate();
    setCurrentDate(newDate);
    setCurrentView("month");
    setShowYearGrid(false);
  };

  // Handle week click in month view
  const handleWeekClick = (date: Date) => {
    setCurrentDate(date);
    setCurrentView("week");
  };

  // Render year grid view
  const renderYearGrid = () => {
    const months = moment.months();
    const year = moment(currentDate).year();

    return (
      <div style={{ padding: "20px" }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <h2
            style={{ textAlign: "center", marginBottom: "30px", cursor: "pointer" }}
            onClick={() => setOpenYearPicker(true)}
          >
            {year}
          </h2>

          <Dialog open={openYearPicker} onClose={() => setOpenYearPicker(false)}>
            <DateCalendar
              value={moment(currentDate)}
              view="year"
              onChange={(newValue) => {
                if (newValue) {
                  const updatedDate = moment(newValue).toDate();
                  setCurrentDate(updatedDate);
                }
                setOpenYearPicker(false);
              }}
            />
          </Dialog>
        </LocalizationProvider>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {months.map((month, index) => {
            const monthStart = moment(currentDate).month(index).startOf("month");
            const monthEvents = filteredEvents.filter((event) =>
              moment(event.start).isSame(monthStart, "month")
            );

            return (
              <div
                key={index}
                onClick={() => handleMonthClick(index)}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "15px",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  transition: "all 0.3s",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                }}
              >
                <h3 style={{ marginBottom: "10px", color: "#ADB792" }}>{month}</h3>
                <p style={{ fontSize: "14px", color: "#666", marginBottom: "8px" }}>
                  {monthEvents.length} event{monthEvents.length !== 1 ? "s" : ""}
                </p>
                <div style={{ maxHeight: "100px", overflowY: "auto" }}>
                  {monthEvents.slice(0, 3).map((event) => (
                    <div
                      key={event.id}
                      style={{
                        fontSize: "12px",
                        padding: "4px",
                        marginBottom: "4px",
                        backgroundColor:
                          event.type === "Created" ? "#fff3cd" : "#d4edda",
                        borderRadius: "3px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {event.title}
                    </div>
                  ))}
                  {monthEvents.length > 3 && (
                    <div style={{ fontSize: "11px", color: "#666", marginTop: "4px" }}>
                      +{monthEvents.length - 3} more
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const generateTimeOptions = () => {
    const options = [];
    const startHour = 9;   // 9 AM
    const endHour = 18;    // 6 PM (18 in 24-hr)

    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += duration === "60" ? 60 : 30) {

        // Skip 18:30 because 6:00 PM is last
        if (hour === endHour && minute > 0) continue;

        const hourStr = hour.toString().padStart(2, "0");
        const minuteStr = minute.toString().padStart(2, "0");
        const time24 = `${hourStr}:${minuteStr}`;

        // Convert to 12-hour format
        let hour12 = hour % 12 || 12;
        const ampm = hour < 12 ? "AM" : "PM";

        const displayTime = `${hour12}:${minuteStr} ${ampm}`;

        options.push(
          <option key={time24} value={time24}>
            {displayTime}
          </option>
        );
      }
    }

    return options;
  };

  // Filter events based on the search query
  const filteredEvents = events?.filter((event) =>
    event.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (event.description &&
      event.description.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  // Handle search input
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  // Custom event styling
  const eventStyleGetter = (event: any) => {
    let backgroundColor = "#ADB792";

    if (event.type === "Created") backgroundColor = "#e4f400ff";
    if (event.type === "Booked") backgroundColor = "#4caf50";
    if (event.type === "completed") backgroundColor = "#CCC"

    return {
      style: {
        backgroundColor,
        color: "white",
        borderRadius: "5px",
        padding: "5px 10px",
        border: "none",
        display: "block",
        margin: "5px 5px 0px 5px",
        wordWrap: "break-word",
        height: 'fit-content',
        maxWidth: 'calc(100% - 10px)',
        right: '0%'
      },
    };
  };

  const formatTime = (date: any) => {
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };
  // Event click handler to open modal for editing
  const onEventClick = (event: Event) => {
    setSelectedDate(event.start ? new Date(event.start) : new Date());
    setAllocationDate(event.start ? new Date(event.start) : new Date());
    setEventDetails(event);
    setNewEventTitle(event.title);
    setNewTrainerName(event.TrainerName);
    setNewAllocation(event.newAllocation);
    setNewEventDescription(event?.availabilityDetails?.notes || "");
    setNewEventType(event.type || "Created");
    setStartTime(event.start ? formatTime(event.start) : '09:00');
    setEndTime(event.end ? formatTime(event.end) : '09:30');
    setseletedSlotId(event?.id)
    setIsModalOpen(true);
    if (event.shopperDetail) {
      setSelectedShopper(event.shopperDetail);
    } else {
      setSelectedShopper(null);
    }

  };

  // Open modal for adding new event
  const handleSelectSlot = (slotInfo: { start: Date; end: Date }) => {
    setSelectedDate(slotInfo.start);
    setNewEventTitle("");
    setNewTrainerName("");
    setNewAllocation("");
    setNewEventDescription("");
    setNewEventType("Created");
    setStartTime('09:00');
    setEndTime('09:30');
    setEventDetails(null);
    setIsModalOpen(true);
    setNewEventFile(null);
    setSelectedShopper(null);
    setAllocationData([]);
    setAllocationDate(slotInfo.start);
    setAllocationSearch("");
  };


  const formatDateTime = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const formatUTCDateTime = (date: any) => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };


  // Save or update event

  const saveEvent = async () => {

    const eventStart = new Date(selectedDate);
    const [startHour, startMin] = startTime.split(':');
    eventStart.setHours(parseInt(startHour), parseInt(startMin), 0);

    const eventEnd = new Date(selectedDate);
    const [endHour, endMin] = endTime.split(':');
    eventEnd.setHours(parseInt(endHour), parseInt(endMin), 0);



    // Validate end time is after start time
    if (eventEnd <= eventStart) {
      alert('End time must be after start time');
      return;
    }

    // Convert to required format
    const eventStartFormatted = formatDateTime(eventStart);
    const eventEndFormatted = formatDateTime(eventEnd);
    const toUTC = (dateInput: string | Date) => {
      const date = dayjs.tz(dateInput, trainderdetails?.timeZone).utc();
      return formatUTCDateTime(date.toDate());           // Convert to native Date
    };

    if (eventDetails) {
      const updatedEvent: Event = {
        ...eventDetails,
        title: newEventTitle,
        description: newEventDescription,
        type: newEventType,
        start: toUTC(eventStartFormatted),
        end: toUTC(eventEndFormatted),
        newAllocation: newAllocation,
        // fileName: newEventFile ? newEventFile.name : eventDetails.fileName
      };
      const updatedEvents = events.map((event) =>
        event.id === updatedEvent.id ? updatedEvent : event
      );
      setEvents(updatedEvents);

    }
    else {
      if ((selectedShopper && !newAllocation) || (!selectedShopper && newAllocation)) {
        alert("Please select both Shopper and Allocation.");
        return;
      }
      try {
        const data = {
          userId: parseInt(selectedAdmin || '0'),
          startDateTime: toUTC(eventStartFormatted),
          endDateTime: toUTC(eventEndFormatted),
          notes: newEventDescription,
          sloatTime: parseInt(duration),
          createdBy: parseInt(localStorage.getItem('userId') || '0'),
          shopperUserId: selectedShopper?.userId,
          allocationId: newAllocation?.allocationId?.allocationId || newAllocation?.allocationId,
          ...(selectedShopper?.userId && newAllocation?.allocationId && {
            isBook: true,
          }),
        };

        const response = await ApiCreateTrainingSlot(data)
        if (response.data) {
          toast.success("Training slot created successfully")
          getTrainingSlots()
        }

      } catch (error: any) {
        console.log("Error", error)
        toast?.error(error)
      }
    }

    setNewEventTitle("");
    setNewTrainerName("");
    setNewAllocation("");
    setNewEventDescription("");
    setNewEventType("Created");
    setseletedSlotId(null)
    setIsModalOpen(false);
    setStartTime('09:00');
    setEndTime('09:30');
    setAllocationDate(null);
  };

  // Update existing event
  const updateEvent = async () => {
    if (!eventDetails) return;

    const eventStart = new Date(selectedDate);
    const [startHour, startMin] = startTime.split(':');
    eventStart.setHours(parseInt(startHour), parseInt(startMin), 0);

    const eventEnd = new Date(selectedDate);
    const [endHour, endMin] = endTime.split(':');
    eventEnd.setHours(parseInt(endHour), parseInt(endMin), 0);

    if (eventEnd <= eventStart) {
      alert('End time must be after start time');
      return;
    }

    if ((selectedShopper && !newAllocation) || (!selectedShopper && newAllocation)) {
      alert("Please select both Shopper and Allocation.");
      return;
    }

    const eventStartFormatted = formatDateTime(eventStart);
    const eventEndFormatted = formatDateTime(eventEnd);
    // const toUTC = (dateStr: any) => new Date(dateStr.replace(" ", "T")).toISOString();
    const toUTC = (dateInput: string | Date) => {
      const date = dayjs.tz(dateInput, trainderdetails?.timeZone).utc();
      return formatUTCDateTime(date.toDate());
    };

    try {
      const data = {
        slotId: seletedSlotId,
        userId: parseInt(searchAdmin || '0'),
        startDateTime: toUTC(eventStartFormatted),
        endDateTime: toUTC(eventEndFormatted),
        notes: newEventDescription,
        sloatTime: 30,
        createdBy: parseInt(localStorage.getItem('userId') || '0'),
        shopperUserId: selectedShopper?.shopperUserId || selectedShopper?.userId || null,
        allocationId: newAllocation?.allocationId?.allocationId || newAllocation?.allocationId || null,
        ...(selectedShopper && newAllocation?.allocationId && {
          ...(newAllocation?.allocationId?.allocationId && newEventType != "Booked" && { isBook: true }),
        }),
      };


      const response = await ApiUpdateAvailabilitySlot(data);

      // const updatedEvent: Event = {
      //   ...eventDetails,
      //   title: selectedShopper ? `${selectedShopper.firstName} ${selectedShopper.lastName}` : "",
      //   description: newEventDescription,
      //   type: (selectedShopper && newAllocation?.allocationId) ? "Booked" : "Created",
      //   start: toUTC(eventStartFormatted),
      //   end: toUTC(eventEndFormatted),
      //   newAllocation: newAllocation,
      //   shopperDetail: selectedShopper,
      // };

      // const updatedEvents = events.map((event) =>
      //   event.id === updatedEvent.id ? updatedEvent : event
      // );
      // setEvents(updatedEvents);

      // toast.success("Training slot updated successfully");

      // setNewEventTitle("");
      // setNewTrainerName("");
      // setNewAllocation("");
      // setNewEventDescription("");
      // setNewEventType("Created");
      // setseletedSlotId(null);
      // setStartTime('09:00');
      // setEndTime('09:30');
      // setSelectedShopper(null);
      // setClientEntityId(null);
      // setAllocationData([]);
      // setAllocationDate(null);

      if (response?.status) {
        setIsModalOpen(false);
        getTrainingSlots();
      }

    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message);
    }
  };
  const CustomToolbar = ({ label, onNavigate, onView, view, date, setShowDatePicker }: any) => {
    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button type="button" onClick={() => onNavigate('TODAY')}>
            Today
          </button>
          <button type="button" onClick={() => onNavigate('PREV')}>
            Back
          </button>
          <button type="button" onClick={() => onNavigate('NEXT')}>
            Next
          </button>
        </span>

        <span
          className="rbc-toolbar-label"
          onClick={() => setShowDatePicker(true)}
          style={{ cursor: 'pointer', userSelect: 'none' }}
        >
          {label}
        </span>

        <span className="rbc-btn-group">
          <button
            type="button"
            className={view === 'month' ? 'rbc-active' : ''}
            onClick={() => onView('month')}
          >
            Month
          </button>
          <button
            type="button"
            className={view === 'week' ? 'rbc-active' : ''}
            onClick={() => onView('week')}
          >
            Week
          </button>
        </span>
      </div>
    );
  };

  // Custom event component for all views
  const CustomEvent = ({ event }: any) => {
    const startTime = moment(event.start).format('h:mm A');
    const endTime = moment(event.end).format('h:mm A');

    return (
      <div style={{
        height: '100%',
        padding: '2px !important',
        color: 'black'
      }}>
        {/* <Typography gutterBottom fontSize={'13px'} fontWeight={'bold'}>Trainer: {event.TrainerName}</Typography> */}
        <Typography gutterBottom fontSize={'14px'} className="m-0 p-0">{startTime}-{endTime}</Typography>
        <Typography gutterBottom fontSize={'14px'} className="m-0 p-0">{event?.newAllocation?.venueName || event?.newAllocation?.allocationId?.venueId?.venueName}</Typography>
        <Typography gutterBottom fontSize={'14px'} >{event.title ? event.title : ''}</Typography>

        {event.description && (
          <div style={{
            fontSize: '11px',
            color: '#666',
            marginTop: '2px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {event.description}
          </div>
        )}
      </div>
    );
  };



  // Custom event for month view (more compact)
  const CustomMonthEvent = ({ event }: any) => {
    const startTime = moment(event.start).format('h:mm A');
    const endTime = moment(event.end).format('h:mm A');

    return (
      <div style={{
        color: 'black',
        borderRadius: '20px'
      }}>
        <Typography gutterBottom className="mb-0" variant="subtitle2">{startTime}  - <span>{endTime}</span></Typography>
        <Typography gutterBottom fontSize={'14px'} className="m-0 p-0">{event?.newAllocation?.venueName || event?.newAllocation?.allocationId?.venueId?.venueName}</Typography>
        <Typography gutterBottom variant="body1" fontWeight={'bold'}>{event.title ? event.title : ''}</Typography>
        {event.description && (
          <Typography variant="subtitle2">
            {event.description.substring(0, 50)}...
          </Typography>
        )}
      </div>
    );
  };

  const handledelteslot = async (slotId: number) => {
    const confirm = window.confirm("Are you sure you want to delete this booking slot")
    if (confirm) {
      try {
        const data = { slotId: slotId }
        const res = await ApiDeleteBookingSlot(data)
        if (res.status) {
          setNewEventTitle("");
          setNewTrainerName("");
          setNewAllocation("");
          setNewEventDescription("");
          setNewEventType("Created");
          setseletedSlotId(null)
          setIsModalOpen(false);
          setStartTime('09:00');
          setEndTime('09:30');
          setAllocationDate(null);

          getTrainingSlots()
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          String(error);
        console.log(message)
      }
    }
    else {
      return
    }
  }

  const completeSlot = async (slotId: number) => {
    try {
      const data = {
        slotId: slotId,
        modifiedBy: Number(localStorage.getItem("userId"))
      }
      const res = await ApiCompleteSlot(data);
      setIsModalOpen(false);
      getTrainingSlots();
      toast.success(res.message);
    } catch (error: any) {
      console.error("Error Completing Slot.", error);
      toast.error(error);
    }
  }
  const ResetSlot = async () => {
    const isConfirm = window.confirm("Are you Sure you want to remove this shopper?")
    if (isConfirm) {
      try {
        const data = {
          allocationId: eventDetails?.newAllocation?.allocationId,
        }
        const res = await ApiResetSlot(data);
        setIsModalOpen(false);
        getTrainingSlots();
        setEventDetails(null)
        toast.success(res.message);
      } catch (error: any) {
        console.error("Error Completing Slot.", error);
        toast.error(error);
      }
    }
  }


  const downloadTrainigList = async () => {
    try {
      const data = `?month=${currentView == "week" ? weekMonth?.split(",")[0] : currentDate?.getMonth() + 1}&year=${currentDate.getFullYear()}`
      const res = await ApiGetMonthlyTrainings(data);

      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Training_List-${currentDate.getFullYear()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error: any) {
      toast.error(error?.message)

    }

  }

  return (
    <div style={{ textAlign: "center", height: "fit-content", padding: "20px 20px 0px 20px", paddingTop: '0px' }}>
      <h1 className="common-manage-h1">{trainderdetails?.displayName ? `${trainderdetails?.displayName}'s` : ''} Training Calendar</h1>

      {/* Search Input */}
      {/* <div style={{ margin: "20px" }}>
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search events by title or description"
          style={{
            width: "50%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
      </div> */}

      {/* View Selection Buttons */}
      <div
        style={{
          display: "flex",
          alignItems: 'center',
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={() => handleNavigate("prev")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#ADB792",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Previous
        </button>
        <div style={{ margin: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
          <button
            onClick={() => { setShowYearGrid(false); setCurrentView("week") }}
            style={{
              padding: "10px 20px",
              backgroundColor: currentView === "week" ? "#ADB792" : "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Week View
          </button>

          <button
            onClick={() => { setShowYearGrid(false); setCurrentView("month") }}
            style={{
              padding: "10px 20px",
              backgroundColor: currentView === "month" ? "#ADB792" : "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Month View
          </button>
          {/* <button
          onClick={() => {
            setShowYearGrid(true);
            setCurrentView("year");
          }}
          style={{
            padding: "10px 20px",
            backgroundColor: showYearGrid ? "#ADB792" : "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Year View
        </button> */}
        </div>

        <Box className="d-flex align-items-center" gap='10px'>
          {adminlist?.find((item: any) => item?.userId == localStorage.getItem('userId'))?.role?.roleId === 1 && (
            <Autocomplete
              id='serach_shopper'
              // disablePortal
              sx={{ width: '300px' }}
              options={adminlist?.filter((item: any) => item.firstName !== '')}
              // value={selectedAdmin}
              value={
                adminlist?.find((item: any) => item.userId == selectedAdmin) || null
              }
              onInputChange={(event, newInputValue) => { setsearchAdmin(newInputValue) }}
              getOptionLabel={(option: any) => `${option?.displayName}`}
              isOptionEqualToValue={(option: any, value: any) =>
                option.userId === value.userId || option.emailId === value.emailId
              }
              filterOptions={(options, { inputValue }) =>
                options.filter((option) => {
                  const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                  const email = option.emailId?.toLowerCase() || '';
                  const search = inputValue.toLowerCase();
                  return fullName.includes(search) || email.includes(search);
                })
              }
              onChange={(event, newValue: any) => {
                if (!newValue) return; // extra safety
                setSelectedAdmin(newValue?.userId)
              }}
              // defaultValue={shopperlist?.filter(item => item.firstName !== '')[0]}
              renderInput={(params) => <TextField {...params} />}
              size="small"
            />
          )}
          <button
            onClick={() => handleNavigate("next")}
            style={{
              padding: "10px 20px",
              backgroundColor: "#ADB792",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Next
          </button>
        </Box>
      </div>
      <div className="w-100 d-flex justify-content-end">
        <button
          onClick={() => { downloadTrainigList() }}
          style={{
            padding: "10px 20px",
            background: "#ADB792",
            border: 'none',
            color: "white",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download Training List
        </button>
      </div>
      {showYearGrid ? (
        renderYearGrid()
      ) : (
        <div style={{ margin: '20px' }}>
          <Calendar
            localizer={localizer}
            events={filteredEvents}
            startAccessor="start"
            endAccessor="end"
            selectable
            popup={false}
            min={new Date(1970, 1, 1, 9, 0, 0)}
            max={new Date(1970, 1, 1, 18, 30, 0)}
            showMultiDayTimes
            style={{ minHeight: "63vh" }}
            eventPropGetter={eventStyleGetter}
            onSelectEvent={onEventClick}
            onSelectSlot={handleSelectSlot}
            date={currentDate}
            view={currentView}
            onView={(view: any) => setCurrentView(view)}
            views={['week', 'month']}
            onNavigate={(date: any) => setCurrentDate(date)}
            onDrillDown={(date: any) => handleWeekClick(date)}
            components={{
              toolbar: (props: any) => (
                <CustomToolbar {...props} setShowDatePicker={setShowDatePicker} />
              ),
              event: CustomEvent,  // For week/day views
              month: {
                event: CustomMonthEvent  // For month view
              }
            }}
            formats={{
              timeGutterFormat: (date: Date, culture: any, localizer: any) => {
                return date.getMinutes() === 0
                  ? localizer.format(date, "h:mm A", culture)
                  : "";
              },
            }}

            step={60}
            timeslots={1}
          />
          <Dialog open={showDatePicker} onClose={() => setShowDatePicker(false)}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              {currentView === "month" && (
                <DateCalendar
                  views={["year", "month"]}
                  value={moment(currentDate)}
                  onChange={(val) => {
                    setCurrentDate(moment(val).toDate());
                    setShowDatePicker(false);
                  }}
                />
              )}

              {currentView === "week" && (
                <DateCalendar
                  value={moment(currentDate)}
                  onChange={(val) => {
                    const startOfWeek = moment(val).startOf("week").toDate();
                    setCurrentDate(startOfWeek);
                    setShowDatePicker(false);
                  }}
                />
              )}
            </LocalizationProvider>
          </Dialog>
        </div>
      )}

      {/* Modal for adding/editing event */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => { setIsModalOpen(false); setseletedSlotId(null); setSelectedShopper(null); setAllocationDate(null); setAllocationSearch(""); }}
        contentLabel="Event Details"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            maxHeight: "90vh",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            width: "500px",
            backgroundColor: "#f9f9f9",
            borderRadius: "10px",
            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
            zIndex: '10000',
            overflow: 'auto'
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: '9999'
          },
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          {eventDetails ? "Edit Training Slot" : "Add New Training Slot"}
        </h3>
        <div>
          <div style={{ marginBottom: "10px" }}>
            <label htmlFor="eventTitle" style={{ display: "block", marginBottom: "5px" }}>
              Trainer Name:
            </label>
            <input
              type="text"
              id="TrainerName"
              disabled
              value={newTrainerName ?? localStorage.getItem('userName')}
              onChange={(e) => setNewTrainerName(e.target.value)}
              placeholder={`${trainderdetails?.userName ?? localStorage.getItem('userName')}`}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <FormControl sx={{ width: "100%" }}>
              <Autocomplete
                id='search_shopper'
                disablePortal
                // disabled={eventDetails?.type === "Booked"} // Disable if already booked
                options={shopperlist?.filter((item: any) => item?.firstName !== '')}
                value={selectedShopper}
                onInputChange={(event, newInputValue) => {
                  setsearchShopper(newInputValue)
                }}
                getOptionLabel={(option: any) =>
                  `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                }
                isOptionEqualToValue={(option: any, value: any) =>
                  option.userId === value.userId || option.emailId === value.emailId
                }
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) => {
                    const fullName = `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`.toLowerCase();
                    const email = option.emailId?.toLowerCase() || '';
                    const search = inputValue.toLowerCase();
                    return fullName.includes(search) || email.includes(search);
                  })
                }
                onChange={(event, newValue: any) => {
                  setSelectedShopper(newValue);
                  if (newValue) {
                    setNewEventTitle(`${newValue.firstName} ${newValue.lastName}`);
                  } else {
                    setNewEventTitle("");
                  }
                }}
                renderInput={(params) =>
                  <TextField
                    {...params}
                    label="Select Shopper"
                    size="small"
                  />
                }
                size="small"
                sx={{ marginBottom: "15px" }}
              />
            </FormControl>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="Select Allocation Date:"
                views={['month', 'year']}
                // disabled={eventDetails}
                value={moment(allocationDate)}
                onChange={(newValue) => {
                  if (newValue) {
                    setAllocationDate(moment(newValue).toDate());
                  }
                }}
                slotProps={{
                  textField: {
                    size: 'small',
                    fullWidth: true,
                    sx: { marginBottom: "15px" }
                  },
                  popper: {
                    sx: {
                      zIndex: 10001
                    }
                  }
                }}
              />
            </LocalizationProvider>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <FormControl size="small" sx={{ width: "100%" }}>
              <Autocomplete
                disablePortal
                id="allocation-autocomplete"
                disabled={!selectedShopper}
                options={allocationData.filter((o: any) => o?.allocationId?.venueId?.venueName || o?.allocationId?.clientEntityId?.entityName)}
                getOptionLabel={(o: any) => {
                  if (!o) return "";
                  if (o?.allocationId?.venueId?.venueName) {
                    return `${o.allocationId.venueId.venueName}${o.allocationId.clientEntityId?.entityName
                      ? ` (${o.allocationId.clientEntityId.entityName})`
                      : ""
                      }`;
                  }
                  if (o?.allocationId?.clientEntityId?.entityName) {
                    return `${o.allocationId.clientEntityId.entityName} - ${o?.allocationId?.differentiateKey || ""}`;
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.allocationId?.allocationId === value?.allocationId?.allocationId ||
                  option?.allocationId?.allocationId === value?.allocationId
                }
                inputValue={allocationInput}
                onInputChange={(event, newInputValue, reason) => {
                  setAllocationInput(newInputValue);

                  if (reason === "input") {
                    setAllocationSearch(newInputValue);
                  }
                }}
                onChange={(event, newValue: any, reason) => {
                  setNewAllocation(newValue);

                  if (reason === "clear") {
                    setAllocationInput("");
                    setAllocationSearch("");
                  }

                  if (newValue) {
                    setAllocationInput(
                      newValue?.allocationId?.venueId?.venueName ||
                      newValue?.allocationId?.clientEntityId?.entityName ||
                      ""
                    );
                  }
                }}

                value={newAllocation}
                renderInput={(params) => (
                  <TextField {...params} label="Search and Select Allocation" />
                )}
                size="small"
                sx={{ marginBottom: "15px" }}
              />
            </FormControl>
          </div>

          {/* Date Display */}
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "5px" }}>
              Date:
            </label>
            <input
              type="text"
              value={selectedDate ? moment(selectedDate).format('MMM DD, YYYY') : ''}
              readOnly
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                backgroundColor: "#e9ecef",
                marginBottom: "15px",
              }}
            />
          </div>

          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>
              Select Duration
            </label>

            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <input
                  type="radio"
                  name="duration"
                  disabled={eventDetails}
                  value="30"
                  checked={duration == "30"}
                  onChange={(e) => setDuration(e.target.value)}
                />
                30 Minutes
              </label>

              <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <input
                  type="radio"
                  name="duration"
                  value="60"
                  disabled={eventDetails}
                  checked={duration == "60"}
                  onChange={(e) => setDuration(e.target.value)}
                />
                60 Minutes
              </label>
            </div>
          </div>

          {/* Start Time */}
          <div style={{ marginBottom: "10px" }}>
            <label htmlFor="startTime" style={{ display: "block", marginBottom: "5px" }}>
              Start Time:
            </label>
            <select
              id="startTime"
              value={startTime}
              disabled={eventDetails}
              onChange={(e) => setStartTime(e.target.value)}
              // onChange={(e) => {
              //   const start = e.target.value;          // selected start time
              //   setStartTime(start);

              //   // Add 1 hour
              //   let [h, m] = start.split(":").map(Number);

              //   // Add 30 minutes
              //   m += 30;

              //   if (m >= 60) {
              //     h = (h + 1) % 24; // increase hour
              //     m -= 60;          // adjust minutes
              //   }

              //   const endTime = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;

              //   setEndTime(endTime);

              // }}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            >
              {generateTimeOptions()}
            </select>
          </div>

          {/* End Time */}
          <div style={{ marginBottom: "10px" }}>
            <label htmlFor="endTime" style={{ display: "block", marginBottom: "5px" }}>
              End Time:
            </label>
            <select
              id="endTime"
              value={endTime}
              disabled={eventDetails}
              // disabled
              onChange={(e) => setEndTime(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            >
              {generateTimeOptions()}
            </select>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <label
              htmlFor="eventDescription"
              style={{ display: "block", marginBottom: "5px" }}
            >
              Notes:
            </label>
            <textarea
              id="eventDescription"
              value={newEventDescription}
              onChange={(e) => setNewEventDescription(e.target.value)}
              placeholder="Enter description"
              rows={4}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                resize: "vertical",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="eventType" style={{ display: "block" }}>
              Status:
            </label>
            <select
              id="eventType"
              value={newEventType}
              disabled
              onChange={(e) => setNewEventType(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Created">Created</option>
              <option value="Booked">Booked</option>
              <option value="Completed">Completed</option>
            </select>
          </div>

          {!eventDetails && (
            <div style={{ textAlign: "center" }}>
              <button
                onClick={saveEvent}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#4caf50",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
              <button
                onClick={() => { setIsModalOpen(false); setAllocationDate(null); setAllocationSearch(""); }}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          )}
          {eventDetails && (
            <div style={{ textAlign: "center", gap: 2, display: "flex", justifyContent: "center" }}>
              {eventDetails?.type !== "Booked" && (
                <button
                  onClick={() => handledelteslot(seletedSlotId)}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#f44336",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              )}
              <button
                onClick={updateEvent}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#4caf50",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  // marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                Update
              </button>

              <button
                onClick={() => completeSlot(seletedSlotId)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "gray",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Complete
              </button>
              {eventDetails?.type === "Booked" && (
                <button
                  onClick={() => ResetSlot(seletedSlotId)}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#ADB792",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                >
                  Reset
                </button>
              )}
            </div>
          )}

        </div>
      </Modal>

    </div>
  );
};

export default TrainingCalendar;

